import { PLAN_FLUX } from "../utils/constants";

export const useTheme = () => {

    /**
     * Contiene método que pisa la paleta de colores para el plan premium flux
     * @param plan
     */
    const fluxTheme = (plan: string) => {
        (plan === PLAN_FLUX) ? document.body.classList.add('p7700') : document.body.classList.remove('p7700');
    }

    return { fluxTheme }
}